"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/tag/style");
var _tag = _interopRequireDefault(require("antd/lib/tag"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../../utils");
var _components = require("../../../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var GroupTopics = function GroupTopics(props) {
  var group = props.group;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    topic = _useState2[0],
    setTopic = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    invalidTopic = _useState4[0],
    setInvalidTopic = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    warningVisible = _useState6[0],
    setWarningVisible = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    commonTopic = _useState8[0],
    setCommonTopic = _useState8[1];
  var _useRequest = (0, _utils.useRequest)((0, _utils.getGroupTopicsByGroupUrl)(group.id), {
      refreshDeps: [group]
    }),
    _useRequest$data = _useRequest.data,
    groupTopics = _useRequest$data === void 0 ? [] : _useRequest$data,
    groupTopicsLoading = _useRequest.loading,
    setGroupTopics = _useRequest.mutate,
    refreshGroupTopics = _useRequest.refreshAsync;
  var _useRequest2 = (0, _utils.useRequest)((0, _utils.getAllGroupTopicsUrl)()),
    _useRequest2$data = _useRequest2.data,
    allGroupTopics = _useRequest2$data === void 0 ? [] : _useRequest2$data,
    allGroupTopicsLoading = _useRequest2.loading,
    refreshAllGroupTopics = _useRequest2.refreshAsync;
  var availableTopics = allGroupTopics.filter(function (_ref) {
    var id1 = _ref.name;
    return !groupTopics.some(function (_ref2) {
      var id2 = _ref2.topic.name;
      return id2 === id1;
    });
  });
  var handleCreateTopic = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!allGroupTopics.some(function (item) {
                return item.name.toLowerCase() === topic.trim().toLowerCase();
              })) {
                _context.next = 4;
                break;
              }
              setCommonTopic(true);
              setWarningVisible(true);
              return _context.abrupt("return");
            case 4:
              setCommonTopic(false);
              if (topic.trim()) {
                _context.next = 9;
                break;
              }
              setInvalidTopic(true);
              setWarningVisible(true);
              return _context.abrupt("return");
            case 9:
              _context.next = 11;
              return createTopic({
                name: topic
              });
            case 11:
              _context.next = 13;
              return refreshGroupTopics();
            case 13:
              setTopic('');
              setInvalidTopic(true);
              setWarningVisible(false);
            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleCreateTopic() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleRemoveTopic = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(topic) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setGroupTopics(groupTopics.filter(function (oldTopic) {
                return oldTopic.id !== topic.id;
              }));
              _context2.next = 3;
              return removeTopic(topic.id);
            case 3:
              _context2.next = 5;
              return refreshGroupTopics();
            case 5:
              _context2.next = 7;
              return refreshAllGroupTopics();
            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function handleRemoveTopic(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleAddTopic = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(topic) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return addTopic(topic.id);
            case 2:
              _context3.next = 4;
              return refreshGroupTopics();
            case 4:
              availableTopics = allGroupTopics.filter(function (_ref6) {
                var id1 = _ref6.name;
                return !groupTopics.some(function (_ref7) {
                  var id2 = _ref7.topic.name;
                  return id2 === id1;
                });
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function handleAddTopic(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var _useRequest3 = (0, _utils.useRequest)(function () {
      return {
        method: 'post',
        url: (0, _utils.createTopicAndAddToGroupUrl)(group.id),
        data: {
          name: topic.trim()
        }
      };
    }, {
      manual: true
    }),
    createTopic = _useRequest3.runAsync;
  var _useRequest4 = (0, _utils.useRequest)(function (topic) {
      return {
        method: 'post',
        url: (0, _utils.addTopicToGroupUrl)(group.id, topic)
      };
    }, {
      manual: true
    }),
    addTopic = _useRequest4.runAsync;
  var _useRequest5 = (0, _utils.useRequest)(function (topicId) {
      return {
        method: 'delete',
        url: (0, _utils.deleteTopicFromGroupUrl)(group.id, topicId)
      };
    }, {
      manual: true
    }),
    removeTopic = _useRequest5.runAsync;
  var handleChange = function handleChange(e) {
    setInvalidTopic(false);
    setTopic(e.target.value);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: allGroupTopicsLoading || groupTopicsLoading
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-medium"
  }, "Current Topics for group: ", group.name), /*#__PURE__*/_react.default.createElement("div", null, groupTopics && groupTopics.map(function (tag, index) {
    return /*#__PURE__*/_react.default.createElement(_tag.default, {
      className: "context-tag border-[1px] p-[12px] rounded-full bg-white text-green1-60 tw-body-sm-regular m-[4px]",
      key: tag.topic.name,
      closable: true,
      onClose: function onClose() {
        return handleRemoveTopic(tag.topic);
      }
    }, tag.topic.name);
  }))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-medium"
  }, "Add More Topics to ", group.name), /*#__PURE__*/_react.default.createElement("div", null, availableTopics && availableTopics.map(function (tag, index) {
    return /*#__PURE__*/_react.default.createElement(_tag.default, {
      className: "context-tag border-[1px] p-[12px] rounded-full bg-white text-green1-60 tw-body-sm-regular m-[4px]",
      key: tag.name,
      closable: false,
      onClick: function onClick() {
        return handleAddTopic(tag);
      }
    }, tag.name);
  }))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
    gutter: 16,
    type: "flex"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-medium"
  }, "Create a new topic for ", group.name)), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-[300px] flex flex-col gap-y-[16px]"
  }, /*#__PURE__*/_react.default.createElement(_components.TextInput, {
    label: "Enter new topic",
    onChange: handleChange,
    value: topic
  })), invalidTopic && warningVisible && /*#__PURE__*/_react.default.createElement("div", null, "Please enter a topic"), commonTopic && warningVisible && /*#__PURE__*/_react.default.createElement("div", null, "Topic not unique, enter a new topic"), /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    className: "mx-[8px] my-[10px]",
    onClick: handleCreateTopic,
    disabled: invalidTopic
  }, "Add"))));
};
var _default = GroupTopics;
exports.default = _default;